/* eslint-disable react/jsx-props-no-spreading */
import React, { type ForwardedRef, forwardRef } from 'react';

import MaterialTab from '@material-ui/core/Tab';
import cn from 'classnames';

import styles from './DeltaUnderlineTabs.module.scss';
import type { UnderlineTabProps } from './DeltaUnderlineTabs.types';

/**
 * @description A wrapper component over Material UI Tab, for providing default styles.
 * It supports all the props accepted by Material UI Tab component.
 *
 * @see [Tabs](https://v4.mui.com/components/tabs/)
 * @see [Tab API](https://v4.mui.com/api/tab/)
 */
const UnderlineTab = forwardRef((props: UnderlineTabProps, ref: ForwardedRef<any>) => {
  const { className, classes = {}, ...restProps } = props;
  const { selected: selectedClassName, ...restClasses } = classes;

  return (
    <MaterialTab
      ref={ref}
      className={cn(styles.underlineTab, className)}
      classes={{ selected: cn(styles.activeTab, selectedClassName), ...restClasses }}
      {...restProps}
    />
  );
});

export { UnderlineTab };
